<template>
  <div>

    <b-button variant="primary" size="sm" @click="onOrganizationSelected(null)">{{$t("operations.create")}}</b-button>
    <organizations-grid ref="organizationGrid" @selected="onOrganizationSelected"/>
    <!--Modal-->
    <organization-modal ref="organization-modal" @closed="e => e.saved && refresh()"/>

  </div>
</template>

<script>

import OrganizationsGrid from '@/components/partial/OrganizationsGrid'
import OrganizationModal from '@/components/modal/OrganizationModal';
import mixinBase from '@/components/mixin/mixinBase';
import mixinPermissions from '@/components/mixin/mixinPermissions';

export default {
  name: 'OrganizationsView',
  components: { OrganizationsGrid, OrganizationModal },
  mixins: [mixinBase, mixinPermissions],
  methods: {
    onOrganizationSelected(selectedId) {
      this.$refs['organization-modal'].showModal(selectedId)
    },
    refresh() {
      this.$refs.organizationGrid.refresh()
    },
  }
};
</script>
